import { setupCreditCardNumberInput } from "./cc_number";
import { setupCCExpirationDateInput } from "./cc_expiration_date";
import { setupCCCVVInput } from "./cc_cvv";

/**
   * Builds Payment inputs inside a given form HTML element,
   * looking out form them in document if none given as parameter
   *
   * @param {HTMLFormElement} form to build the inputs inside
   * @returns {Object} object with data getters and validators
   */
export function setupCreditCardForm(options = {}) {
  const creditCardNumberInput = options.numberInput
    || document.querySelector(
      options.numberQuerySelector
      || "#payment-input-form .credit-card-number-input"
    );
  const expirationDateInput = options.expirationInput
    || document.querySelector(
      options.expirationQuerySelector
      || "#payment-input-form .credit-card-expiration-date-input"
    );
  const cvvInput = options.cvvInput
    || document.querySelector(
      options.cvvQuerySelector ||
      "#payment-input-form .credit-card-cvv-input"
    );

  const creditCardNumber = setupCreditCardNumberInput(creditCardNumberInput);
  const expirationDate = setupCCExpirationDateInput(expirationDateInput);
  const cvv = setupCCCVVInput(cvvInput);

  return {
    creditCardNumber,
    expirationDate,
    cvv
  };
}